module.exports = __webpack_public_path__ + "static/img_9-2af15f8941fd64ea0c4557f1c8fc79f4.png";